<section class="text-center corporate-banner">
  <img class="banner-img" src="assets/images/corporate-banner.jpg" alt="corporate-banner">
  <span class="yoga-icn"><img src="assets/images/corp-yoga-icon.svg" alt="corp-yoga-icon"></span>
  <div class="banner-wrap text-center">
    <div class="container d-flex">
      <div class="banner-content">
        <h1 class="banner-title">MyWorkWell</h1>
        <p class="banner-desc">Give your employees the gift of wellness and empower them to lead healthier, happier
          lives.</p>
        <span class="arrow"><img src="assets/images/arrow-icn.svg" alt="arrow"></span>
        <div>
          <a (click)="scrolltoform()" class="enquirytop btn text-uppercase">ENQUIRE NOW</a>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="organisation-sec text-center">
  <div class="container">
    <h4>Bringing Comprehensive Wellness To Your Workplace</h4>
    <span class="desc-tags text-capitalize">
      <span>Live Well</span> &nbsp;
      <span>· &nbsp; Travel Well </span> &nbsp;
      <span>· &nbsp; Work Well </span> &nbsp;
    </span>
    <p class="desc">With MyLifeWell, you can offer a variety of programs to help your employees reduce stress and
      increase trust and productivity while reducing your organization’s turnover and medical expenditures. We can
      create a wellness program tailored to the needs of your business and scale it to grow with your organization.</p>
  </div>
</section>
<section class="offering-sec">
  <div class="container">
    <h4 class="text-center">Our Solutions</h4>
    <div class="offer-rw d-md-flex justify-content-md-between">
      <div class="offer-pics d-md-flex order-md-2">
        <div class="vertical-view d-none d-md-block"><img src="assets/images/corp-leader-img01.jpg" alt="img"></div>
        <div class="horizontal-view">
          <div><img src="assets/images/corp-leader-img02.jpg" alt="img"></div>
          <div class="d-none d-md-block"><img src="assets/images/corp-leader-img03.jpg" alt="img"></div>
        </div>
      </div>
      <div class="offter-info text-center text-md-left order-md-1">
        <h6>Virtual Team Building Program</h6>
        <p class="desc">3Ms For Boosting Productivity: Mindfulness, Movement, Meditation</p>
        <p class="desc">Fun filled and power packed health & wellness programming delivering tools your team can
          implement immediately to increase productivity and foster connection.</p>
        <p class="desc">With teams working remotely across the country and around the world, it is even more important
          to come together virtually and create camaraderie. The program is completely flexible and provides a wealth of
          information focusing on- mindfulness, movement, and meditation- to promote overall wellbeing and help your
          team thrive.</p>
        <p class="desc"><strong>Sample Program:</strong></p>
        <p class="desc no-space"><strong>5-minute:</strong> Introduction to wellness</p>
        <p class="desc no-space"> <strong>10-Minute:</strong> Productivity pause/guided meditation to activate the
          relaxation response.</p>
        <p class="desc no-space"><strong>15-Minute:</strong> Stretching & energizing exercise - interactive experience
          (Yoga, Qigong, or Functional Fitness)</p>
        <p class="desc no-space"><strong>10-Minute:</strong> 3 ways to interrupt patterns of stress or anxiety</p>
        <p class="desc no-space"><strong>10-Minute:</strong> How to cultivate mindfulness to be more present in your
          life and work</p>
        <p class="desc"><strong>10-Minute:</strong> Q&A and closing statement</p>
        <a (click)="scrolltoform()" class="enquirytop btn"><span>Enquire Now</span></a>
      </div>
    </div>
    <div class="offer-rw d-md-flex justify-content-md-between">
      <div class="offer-pics d-md-flex">
        <div class="vertical-view">
          <img src="assets/images/corp-well-img01.jpg" alt="img">
        </div>
      </div>
      <div class="offter-info text-center text-md-left">
        <h6>Workplace Wellness Programs</h6>
        <p class="desc">In a recent survey conducted by the mental health provider Ginger, nearly 7 in 10 employees
          reported that the COVID-19 pandemic is the most stressful time of their entire professional career. Now more
          than ever, your workplace wellness programs will help you retain your current employees as well as attract new
          talent. MyLifeWell will work with you to design a workplace wellness program that caters to the needs of
          employees at all levels. Our programs include:</p>
        <p class="desc"><strong>Assessments:</strong> From on site health screenings to online mental health
          evaluations, we have the tools and technology to gauge the physical and mental well-being of each team member.
        </p>
        <p class="desc"><strong>Wellness Coaching:</strong> Virtual sessions with life, health and wellness coaches to
          help employees create a holistic plan for healthy living.</p>
        <p class="desc"><strong>On-demand and live classes:</strong> Access to on demand and live stream virtual
          programs offering an array of wellness options from nutrition to fitness to stress management and more.</p>
        <p class="desc"><strong>Team Challenges:</strong> Invite team members to a virtual fitness class, earn badges,
          and vie for the top position on the leader board</p>
        <a (click)="scrolltoform()" class="enquirytop btn"><span>Enquire Now</span></a>
      </div>
    </div>
    <div class="offer-rw d-md-flex justify-content-md-between">
      <div class="offer-pics d-md-flex order-md-2">
        <div class="vertical-view d-none d-md-block"><img src="assets/images/corp-virtual-img01.jpg" alt="img"></div>
        <div class="horizontal-view">
          <div><img src="assets/images/corp-virtual-img02.jpg" alt="img"></div>
          <div class="d-none d-md-block"><img src="assets/images/corp-virtual-img03.jpg" alt="img"></div>
        </div>
      </div>
      <div class="offter-info text-center text-md-left order-md-1">
        <h6>Corporate & Leadership Retreats</h6>
        <p class="desc">Nothing promotes creativity more than getting out of the office and into nature. Walk among the
          redwoods or paddle across turquoise waters – we can create the perfect mix of activities to help your team
          rest, recharge and return refreshed.</p>
        <p class="desc"><strong>Team building activities to help you connect:</strong> From hiking to biking to
          kayaking, choose a variety of options to bring the team together in active and fun ways</p>
        <p class="desc"><strong>Workshops for personal growth and development:</strong> Learn tools for healthy living
          and how to apply them when you return home</p>
        <p class="desc"><strong>Personal time to reset:</strong> Choose spa, yoga, or pool time, whatever each team
          member needs to unwind</p>
        <p class="desc"><strong>Flexible programs:</strong> Choose a full day getaway close to work or a week long
          escape across the globe</p>
        <a (click)="scrolltoform()" class="enquirytop btn"><span>Enquire Now</span></a>
      </div>
    </div>
  </div>
</section>
<section class="booking-sec text-center">
  <div class="container">
    <h4 class="booking-title">Why MyWorkWell?</h4>
    <div class="d-md-flex justify-content-md-between">
      <div class="bhook-item">
        <span class="booking-count">01</span>
        <strong class="book-heading">One-Stop-Shop</strong>
        <p class="book-desc">All the tools your employees need for healthy living in one convenient place</p>
      </div>
      <div class="bhook-item">
        <span class="booking-count">02</span>
        <strong class="book-heading">Flexible programming</strong>
        <p class="book-desc">From one hour to one year, our programs can scale with your organization’s needs</p>
      </div>
      <div class="bhook-item">
        <span class="booking-count">03</span>
        <strong class="book-heading">Service & Value</strong>
        <p class="book-desc">A dedicated concierge to ensure you are supported and that you receive the most value for
          your wellness spend </p>
      </div>
    </div>
  </div>
</section>
<section class="benefits-section media-section">
  <div class="container">
    <h2>Our Brand Partner Highlights</h2>
    <ul class="d-flex steps-combo brands-step top-brands">
      <li>
        <a>
          <img src="assets/images/partner-logo1.png" alt="partner-logos">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo2.jpg" alt="partner-logo">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo3.jpg" alt="partner-logo">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo4.jpg" alt="madenew">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo5.png" alt="madenew">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo6.png" alt="partner-logo">
        </a>
      </li>

    </ul>
    <ul class="d-flex steps-combo brands-step">
      <li>
        <a>
          <img src="assets/images/partner-logo7.jpg" alt="partner-logo">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo8.jpg" alt="partner-logo">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo9.png" alt="partner-logo">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo10.jpg" alt="partner-logo">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo11.png" alt="partner-logo">
        </a>
      </li>
      <li>
        <a>
          <img src="assets/images/partner-logo12.png" alt="partner-logo">
        </a>
      </li>
    </ul>
    <p></p>
  </div>
</section>
<section class="enquiry-form" id="enquiry_form_hubspot">
  <div class="container">
    <h4 class="enquiry-title text-center">Let’s Start Your WorkWell Conversation</h4>
    <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/v2.js"></script>
    <script>
      hbspt.forms.create({
        portalId: "8304524",
        formId: "eea979e4-bfa6-4902-89db-d1edc0585119",
        locale: 'en',
        inlineMessage: "Thank you for your interest in partnering with MyLifeWell. Our team will review your application and be in touch within 3-5 business days.",
      });
    </script>
    <div id="form-target"></div>
  </div>
</section>
<div class="feature-subscribe start-subscribe">
  <div class="subs-detail d-md-flex  justify-content-md-between align-items-center">
    <p class="subs-desc"><span class="subs-arrow"><i class="icon-arrow"></i></span><strong> Subscribe for latest
        offers.</strong></p>
    <div class="start-subscribe">
      <form class="form-wrap d-flex justify-content-between" [formGroup]="emailForm">
        <div class="input-wrap">
          <input type="text" formControlName="email" placeholder="Email Address">
          <div *ngIf="submitted && f.email.errors" class="invalid-feedback">

            <div *ngIf="f.email.errors.required" style="color: white">Please enter the email address where you'd like to
              receive our newsletter
            </div>
            <div *ngIf="f.email.errors.passwordCheck" style="color: white">Please enter your email address in the format
              yourname@example.com</div>
          </div>
        </div>
        <div><button (click)="submit()">Submit</button></div>
      </form>
    </div>
  </div>
</div>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>